import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceTaxRatesAction from '../actions/ecommerce-tax-rates.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommerceTaxRates} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {TaxRateMapper} from "../../websites/website/ecommerce/ecommerce-tax/tax-rate-table/mapper/tax-rate-mapper";

@Injectable()
export class EcommerceTaxRatesEffect {

  loadEcommerceTaxRates = createEffect(() => this._actions$.pipe(
    ofType(EcommerceTaxRatesAction.LOAD_ECOMMERCE_TAX_RATES),
    mergeMap((action: LoadEcommerceTaxRates) => {
      const {websiteId} = action.payload;
      return this._ecommerceService.getTaxRates(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
              if (response.success && response?.data?.dataKey) {
              const data = (response?.data?.dataKey).map(TaxRateMapper.map);
              return new EcommerceTaxRatesAction.LoadEcommerceTaxRatesSuccess({
                data: data,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommerceTaxRatesAction.LoadEcommerceTaxRatesFail({websiteId});
          })
        );
    })
  ));



  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
